import { AppTab, AppTabList, AppTabTrigger, AppTooltip } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import type { ACLType } from 'backend/types'
import type { OpportunityTab } from './tabs'

/**
 * TabSelector コンポーネントの Props
 *
 * @param tabs - タブ一覧
 * @param value - 選択中のタブキー
 * @param onChange - タブ変更ハンドラ
 * @param user - ユーザー情報（タブの表示制御用）
 */
interface TabSelectorProps {
  tabs: OpportunityTab[]
  value: string
  onChange: (value: string) => void
  user: {
    isCaptain?: boolean
    isServiceManager?: boolean
    isProjectManager?: boolean
    isSalesMember?: boolean
    acl?: ACLType
  }
}

/**
 * TabSelector - オポチュニティ一覧のタブセレクター
 */
export function TabSelector({ tabs, value, onChange, user }: TabSelectorProps) {
  return (
    <AppTab value={value} onValueChange={onChange} className='w-full'>
      <AppTabList className='flex w-full'>
        {tabs.map((tab) => (
          <AppTooltip key={tab.key} content={tab.description} side='bottom' sideOffset={4}>
            {/** AppTooltip直下にAppTabTriggerがあるとdata-[state=active]属性の伝播に問題が発生するためspanを配置 */}
            <span className='flex-1 min-w-0'>
              <AppTabTrigger value={tab.key} className='w-full truncate text-sm' disabled={tab.isDisabled(user)}>
                {tab.label}
              </AppTabTrigger>
            </span>
          </AppTooltip>
        ))}
      </AppTabList>
    </AppTab>
  )
}
